import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import axios from 'axios';
import { useToast } from './ui/use-toast';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const EditBankAccountModal = ({ clientId, account, onClose }) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    account_number: account.account_number || '',
    account_name: account.account_name || '',
    ach_routing: account.ach_routing || '',
    wire_routing: account.wire_routing || '',
    type: account.type || 'Checking',
    bank_name: account.bank_name || '',
    is_main: account.is_main || false
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('mcaToken');
      await axios.put(`${API_BASE}/clients/${clientId}/bank-accounts/${account.client_id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: 'Success', description: 'Bank account updated successfully' });
      onClose();
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to update bank account', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Edit Bank Account</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Account Number *</label>
              <Input required value={formData.account_number} onChange={(e) => setFormData({...formData, account_number: e.target.value})} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Account Name *</label>
              <Input required value={formData.account_name} onChange={(e) => setFormData({...formData, account_name: e.target.value})} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">ACH Routing # *</label>
              <Input required value={formData.ach_routing} onChange={(e) => setFormData({...formData, ach_routing: e.target.value})} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Wire Routing # *</label>
              <Input required value={formData.wire_routing} onChange={(e) => setFormData({...formData, wire_routing: e.target.value})} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Account Type *</label>
              <select required value={formData.type} onChange={(e) => setFormData({...formData, type: e.target.value})} className="w-full border rounded p-2">
                <option>Checking</option>
                <option>Savings</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Bank Name *</label>
              <Input required value={formData.bank_name} onChange={(e) => setFormData({...formData, bank_name: e.target.value})} />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <input type="checkbox" checked={formData.is_main} onChange={(e) => setFormData({...formData, is_main: e.target.checked})} className="w-4 h-4" />
            <label className="text-sm font-medium">Set as Main Account</label>
          </div>
          <div className="flex gap-3 pt-4">
            <Button type="submit" disabled={loading} className="flex-1 bg-orange-500 hover:bg-orange-600">{loading ? 'Saving...' : 'Save Changes'}</Button>
            <Button type="button" variant="outline" onClick={onClose} className="flex-1" disabled={loading}>Cancel</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBankAccountModal;